// Get initials from name by getting first
export const extractInitials = (name) => name.split(/[._-]/)
  .map((val) => val.charAt(0))
  .join('')
  .slice(0, 2);

export function lowerCaseFirstLetter (string) {
  if (typeof string !== 'string') {
    return ''
  }

  if (string.length === 0) {
    return string
  }
  return string[0].toLowerCase() + string.slice(1)
}